import { AwaitResponse } from '@general/js/utils/MockUtils';
import { coverDetailsOpenExcess } from '@/constants/ChangeExcessMockApiData';
import ChangeExcessAbstractServices from './ChangeExcessAbstractServices';

export default class ChangeExcessServicesMock extends ChangeExcessAbstractServices {
  static getReferenceData() {
    return AwaitResponse({
      changeMyExcessDescriptionText: {
        informationText:
          'To make multiple&nbsp;changes&nbsp;to your policy&nbsp;today, go to <a href="/portal/$memberNumber$/my-cover/change-my-cover">Change My&nbsp;Cover</a>.<br />\r\n<br />\r\nIf your hospital cover&nbsp;has an excess, this is&nbsp;the amount you pay&nbsp;towards your hospital&nbsp;admission (same day or&nbsp;overnight) before we&nbsp;pay any benefits. You&nbsp;only ever pay an excess&nbsp;if&nbsp;you&rsquo;re&nbsp;admitted to&nbsp;hospital. Generally, the&nbsp;higher the excess the&nbsp;lower the premium.&nbsp;',
      },
      noExcessOptionsErrorText: {
        informationText: 'There are no other excess options available for your current product.',
      },
      premiumChangeCalloutText: {
        informationText: 'Your premium will change depending on the excess you choose.<br />\r\n<br />\r\nYour updated premium will be displayed in the next step',
      },
      excessOptionsCalloutText: {
        informationText: 'The excess options available to you will depend on the product you are currently on.',
      },
      reviewAndSubmitInformationText: {
        informationText: 'Important fields are indicated by an information icon',
      },
    });
  }

  static getPremiumImpactReferenceData() {
    return AwaitResponse({
      premiumImpactTitleText: {
        informationText: 'Your excess update was successful',
      },
      premiumImpactDescriptionText: {
        informationText:
          'Your premium has been updated based on your selected excess. The higher the excess amount, the lower the premium.<br />\r\n<br />\r\nYour excess and premium changes are displayed below. You will receive a certificate of cover reflecting this change.',
      },
      updatedProductInformationText: {
        informationText:
          '\r\n\t<strong>#{newExcess} Hospital excess</strong>, payable once per #{excessType} per financial year<br /> <br />\r\n\tThe excess update is effective from <strong>#{nextPaymentDate}</strong>. Your premium will change from your next payment, but excess payable may not change for up to 12 months <br /> <br />\r\n\t<a href="/portal/$memberNumber$/my-cover/My-waiting-periods">See your updated list of waiting periods per service</a>\r\n',
      },
      adjustedPaymentInformationText: {
        informationText: 'Any changes to your premium will be automatically adjusted in your next bill. Alternatively, you can pay for the remaining amount due now.',
      },
    });
  }

  static getCoverDetails() {
    return AwaitResponse(coverDetailsOpenExcess);
  }

  static getPremiumOnNewExcess() {
    return AwaitResponse({
      currentPremium: 372.87,
      newPremium: 421.82,
    });
  }

  static submitNewExcess() {
    return AwaitResponse({
      newPremium: 421.82,
    });
  }
}
